import { Col as AntCol } from 'antd';
import styled from 'styled-components';

export const Col = styled(AntCol)``;
